const steps = [
  {
    icon: "ri-search-line",
    title: "找到想看的番剧",
    desc: "进入小猴看番，搜索或浏览你感兴趣的番剧，进入播放详情页。",
  },
  {
    icon: "ri-settings-3-line",
    title: "自动优选源加载",
    desc: "页面自动探测各线路可用性，优先加载最稳定的播放源，无需手动设置。",
  },
  {
    icon: "ri-play-circle-line",
    title: "开始流畅播放",
    desc: "正片即刻开播，清晰度和播放进度自动记忆，接着上次位置继续看。",
  },
  {
    icon: "ri-shuffle-line",
    title: "卡顿就秒切线路",
    desc: "播放不流畅时点开线路切换，选择备用线路一键秒切，画面快速恢复。",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="inline-block rounded-full bg-accent-100 px-4 py-1 text-sm font-medium text-accent-900">
              使用教程
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">
              三步上手，卡顿随时自救
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              小猴看番把线路切换、多源播放和自动选源做进播放器的每一步。
              不需要任何技术知识，跟着引导就能找到最流畅的观看线路。
            </p>

            <div className="mt-8 flex flex-col gap-4">
              {steps.map((s, i) => (
                <div
                  key={s.title}
                  className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className={`${s.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h3 className="text-base font-semibold text-foreground-950">
                      <span className="mr-2 text-sm text-secondary-600">0{i + 1}</span>
                      {s.title}
                    </h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-700">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex items-center">
            <div className="w-full rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="rounded-md bg-foreground-950 p-4">
                <div className="flex items-center gap-2">
                  <span className="flex h-3 w-3 rounded-full bg-primary-400"></span>
                  <span className="flex h-3 w-3 rounded-full bg-secondary-400"></span>
                  <span className="flex h-3 w-3 rounded-full bg-accent-400"></span>
                </div>
                <div className="mt-4 flex items-center gap-3 rounded-md bg-foreground-900 p-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className="ri-tv-2-line"></i>
                  </span>
                  <div className="min-w-0">
                    <p className="truncate text-sm font-medium text-foreground-50">幻夜之都 · 第 12 集</p>
                    <p className="text-xs text-foreground-400">正在播放 · 线路 2</p>
                  </div>
                  <span className="ml-auto rounded-full bg-accent-500 px-2 py-0.5 text-xs text-background-50">
                    流畅
                  </span>
                </div>

                <div className="mt-4">
                  <p className="text-xs text-foreground-400">播放线路</p>
                  <div className="mt-2 flex flex-wrap gap-2">
                    <span className="rounded-md bg-primary-500 px-3 py-1 text-xs text-background-50">线路 1</span>
                    <span className="rounded-md bg-foreground-800 px-3 py-1 text-xs text-foreground-200">线路 2</span>
                    <span className="rounded-md bg-foreground-800 px-3 py-1 text-xs text-foreground-200">备用 3</span>
                    <span className="rounded-md bg-foreground-800 px-3 py-1 text-xs text-foreground-200">备用 4</span>
                  </div>
                  <div className="mt-3 flex items-center justify-between rounded-md bg-foreground-900 px-3 py-2">
                    <span className="text-xs text-foreground-300">
                      <i className="ri-speed-line mr-1"></i>自动选源已开启
                    </span>
                    <span className="text-xs text-accent-300">实时探测</span>
                  </div>
                </div>
              </div>

              <div className="mt-4 space-y-2">
                <div className="flex items-center justify-between rounded-md bg-accent-100 px-3 py-2 text-sm text-accent-900">
                  <span className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-accent-600"></i>
                    检测到当前线路延迟升高
                  </span>
                </div>
                <div className="flex items-center justify-between rounded-md bg-background-100 px-3 py-2 text-sm text-foreground-800">
                  <span className="flex items-center gap-2">
                    <i className="ri-swap-line text-primary-600"></i>
                    已自动切换至备用线路 3
                  </span>
                  <span className="text-xs text-secondary-600">约 0.4 秒</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}